/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Directory_Submit_Review_Choose_Plan_DescInputs */

const en_directory_submit_review_choose_plan_desc = /** @type {(inputs: Directory_Submit_Review_Choose_Plan_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your draft is saved. Choosing an option moves it into review. After that, editors check the listing and ${i?.app} automatically runs its AI Readiness and GEO Score assessments. Those scores are platform-owned and cannot be edited.`)
};

const zh_directory_submit_review_choose_plan_desc = /** @type {(inputs: Directory_Submit_Review_Choose_Plan_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你的草稿已经保存。选择一个方式后进入审核。之后由编辑审核，${i?.app} 自动运行 AI 就绪度和 GEO Score 评估。评分归平台所有，用户不能编辑。`)
};

/**
* | output |
* | --- |
* | "Your draft is saved. Choosing an option moves it into review. After that, editors check the listing and {app} automatically runs its AI Readiness and GEO Sco..." |
*
* @param {Directory_Submit_Review_Choose_Plan_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_choose_plan_desc = /** @type {((inputs: Directory_Submit_Review_Choose_Plan_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Choose_Plan_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_choose_plan_desc(inputs)
	return zh_directory_submit_review_choose_plan_desc(inputs)
});
export { directory_submit_review_choose_plan_desc as "directory.submit.review.choose_plan_desc" }